import { createSelector } from 'reselect';

const selectForumTopics = (state: any) => state.forumTopics;


export const selectForumTopicsCurrentItem = createSelector([selectForumTopics], (forumTopics) => forumTopics.current);

export const selectForumTopicsListItems = createSelector([selectForumTopics], (forumTopics) => forumTopics.list);

export const selectForumTopicsItemById = (itemId: any) =>
    createSelector(selectForumTopicsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectForumTopicsQueryItems = createSelector([selectForumTopics], (forumTopics) => forumTopics.query);

export const selectForumTopicsCreatedItem = createSelector([selectForumTopics], (forumTopics) => forumTopics.create);

export const selectForumTopicsUpdatedItem = createSelector([selectForumTopics], (forumTopics) => forumTopics.update);

export const selectForumTopicsReadItem = createSelector([selectForumTopics], (forumTopics) => forumTopics.read);

export const selectForumTopicsDeletedItem = createSelector([selectForumTopics], (forumTopics) => forumTopics.delete);

export const selectForumTopicsSearchedItems = createSelector([selectForumTopics], (forumTopics) => forumTopics.search);

export const selectForumTopicsItemsCount = createSelector([selectForumTopics], (forumTopics) => forumTopics.count);

export const selectForumTopicsItemsFilter = createSelector([selectForumTopics], (forumTopics) => forumTopics.filter);